// import React from "react";
// import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
// import Navbar from "../components/Navbar";
// import Home from "../pages/Home";
// // import Shop from "../pages/Shop";

// import { CartProvider } from "../components/CartContext";
// import OrderSummary from "../pages/OrderSummary";
// import Products from "../pages/Products"; // Updated import
// import ProductView from "../pages/ProductView";
// import Contact from "../pages/Contact";
// import Aboutus from "../pages/Aboutus";
// import Card from "../components/Card";
// import Populer from "../components/Populer";
// import Feat from "../components/Feat";
// import SubscribeNewsletter from "../components/SubscribeNewsletter";
// import Checkout from "../pages/Checkout";
// import Footer from "../components/Footer";
// import { ModeProvider } from "../components/ModeContext";
// import Profile from "../pages/Profile";
// import NotFound from "../pages/NotFound";
// import Login from "../pages/Login";
// import Signup from "../pages/Signup";

// const Routess = () => {
//   return (
//     <CartProvider>
//       <Router>
//         <Navbar />
//         <ModeProvider>
//           <div>
//             <Routes>
//               <Route path="/" element={<Home />} />
//               <Route path="/card" element={<Card />} />
//               {/* <Route path="/shop" element={<Shop />} /> */}
//               <Route path="/product" element={<Products />} />{" "}
//               {/* Product List */}
//               <Route path="/product/:id" element={<ProductView />} />
//               <Route path="/Contact" element={<Contact />} />
//               <Route path="/aboutus" element={<Aboutus />} />
//               <Route path="/populer" element={<Populer />} />
//               <Route path="/feat" element={<Feat />} />
//               <Route
//                 path="/SubscribeNewsletter"
//                 element={<SubscribeNewsletter />}
//               />
//               <Route path="/checkout" element={<Checkout />} />
//               <Route path="/OrderSummary" element={<OrderSummary />} />
//               <Route path="/profile" element={<Profile />} />
//               <Route path="/footer" element={<Footer />} />
//               <Route path="/login" element={<Login />} />
//               <Route path="/signup" element={<Signup />} />
//               <Route path="*" element={<NotFound />} />
//             </Routes>
//           </div>
//         </ModeProvider>
//         <Footer />
//       </Router>
//     </CartProvider>
//   );
// };

// export default Routess;

import React from "react";
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
import Navbar from "../components/Navbar";
import Home from "../pages/Home";
// import Shop from "../pages/Shop";

import { CartProvider } from "../components/CartContext";
import OrderSummary from "../pages/OrderSummary";
import Products from "../pages/Products"; // Updated import
import ProductView from "../pages/ProductView";
import Contact from "../pages/Contact";
import Aboutus from "../pages/Aboutus";
import Card from "../components/Card";
import Populer from "../components/Populer";
import Feat from "../components/Feat";
import SubscribeNewsletter from "../components/SubscribeNewsletter";
import Checkout from "../pages/Checkout";
import Footer from "../components/Footer";
import { ModeProvider } from "../components/ModeContext";
import Profile from "../pages/Profile";
import NotFound from "../pages/NotFound";
import Login from "../pages/Login";
import Signup from "../pages/Signup";
import WhatsAppFloat from "../components/WhatsAppFloat";
import OrderConfirmation from '../pages/OrderConfirmation';
import GuestProfile from "../pages/guestprofile";
import ConvertGuest from "../pages/convertguest";
import PrivacyPolicy from "../pages/privacyPolicy";
import Terms from "../pages/termsAndCondition";

const Layout = ({ children }) => {
  const location = useLocation();
  const isAuthPage = ['/login', '/signup', '/convert-guest'].includes(location.pathname);

  return (
    <>
      {!isAuthPage && <Navbar />}
      {children}
      {!isAuthPage && (
        <>
          <WhatsAppFloat />
          <Footer />
        </>
      )}
    </>
  );
};

const Routess = () => {
  return (
    <CartProvider>
      <Router>
        <ModeProvider>
          <Layout>
            <div>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/card" element={<Card />} />
                <Route path="/product" element={<Products />} />
                <Route path="/product/:id" element={<ProductView />} />
                <Route path="/Contact" element={<Contact />} />
                <Route path="/aboutus" element={<Aboutus />} />
                <Route path="/populer" element={<Populer />} />
                <Route path="/feat" element={<Feat />} />
                <Route
                  path="/SubscribeNewsletter"
                  element={<SubscribeNewsletter />}
                />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/order-confirmation" element={<OrderConfirmation />} />
                <Route path="/OrderSummary" element={<OrderSummary />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/login" element={<Login />} />
                <Route path="/signup" element={<Signup />} />
                <Route path="/guest-profile" element={<GuestProfile />} />
                <Route path="/convert-guest" element={<ConvertGuest />} />
                <Route path="privacy-policy" element={<PrivacyPolicy />}/>
                <Route path="terms-conditions" element={<Terms />}/>
                <Route path="*" element={<NotFound />} />
              </Routes>
            </div>
          </Layout>
        </ModeProvider>
      </Router>
    </CartProvider>
  );
};

export default Routess;